import ApiService from '../apiservice'

export default class TermosPublicacoesAtividadeService extends ApiService {
  constructor() {
    super('/termos-publicacoes-atividade');
  }

  listar(empresaId) {
    return this.get(`/${empresaId}`);
  }

  cadastrar(termo) {
    return this.post('/', termo);
  }

  alterar(termo) {
    return this.put('/', termo);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}
